import { Datalayer, DatalayersMap } from "../../../../omnia"
import { insertNewGeometry } from "../add"

import DrawMarginInteraction = omnia.map.DrawMarginInteraction
import { ol_Feature, ol_source, ol_geom } from "@omnia/exports/openlayers"

export class BufferOperation {

    public keepMarginWhole: boolean = true

    private context: DrawBufferContext

    constructor(private map: DatalayersMap, private layer: Datalayer, private topo: omnia.map.IMapTopologyService, private outerGeometry: () => ol_geom.Geometry, private apply: () => void) {

        this.context = new DrawBufferContext(map, topo)

    }

    get dimensions() {
        return this.context.getCurrentDimensions()
    }

    get width() {
        return this.context.width
    }

    set width(value) {
        this.context.width = value
    }

    get fullBoundary() {
        return this.context.fullBoundary
    }

    set fullBoundary(value) {
        this.context.fullBoundary = value
    }

    start() {
        this.stop()
        this.map.enableContextMenu = false
        this.context.startDrawing(this.outerGeometry(), this.apply)
    }


    stop() {
        this.context.dispose()
        this.map.enableContextMenu = true
    }

    canCommit() {

        return this.context.canCommit()

    }

    commit() {

        if (!this.context.canCommit()) return false

        const selection = this.context.selection
        if (!selection) return false

        const margin = this.context.bufferMargin(selection, true)

        return insertNewGeometry(margin, this.layer, this.topo, !this.keepMarginWhole)

    }

}

class DrawBufferContext extends omnia.map.DrawMarginContext<DatalayersMap> {

    startDrawing(outerGeometry: ol_geom.Geometry, apply: () => void) {

        this.dispose()

        this.setupInteraction(outerGeometry)

        this._width = this._width || 10
        this._fullBoundary = false

        this.interaction.geometryFunction = line => this.bufferMargin(line, false)

        this.setupChangeWatcher(() => {
            this._currentDimensions = undefined
            apply()
        })

        this.interaction.setActive(true)

    }

    private setupInteraction(outerGeometry: ol_geom.Geometry) {

        const targetFeature = new ol_Feature(outerGeometry)
        const source = new ol_source.Vector({ features: [targetFeature] })

        this.interaction = new DrawMarginInteraction(source)

        this.olmap.addInteraction(this.interaction)


    }

}
